import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;

// `posthogEnabled` is a LIVE module binding: it is false until PostHog has
// actually been initialised, and flips to true the moment initPostHog() runs.
// Downstream guards (`if (posthogEnabled) posthog.capture(...)`) import it, so
// nothing is tracked until the visitor has granted cookie consent — a rejected
// or undecided visitor never initialises PostHog and every guard stays false.
export let posthogEnabled = false;

// Init is NO LONGER automatic on import. It fires only when the cookie-consent
// gate calls initPostHog() after the visitor accepts (see CookieConsent.jsx).
export function initPostHog() {
  if (posthogEnabled) return; // already initialised — idempotent

  if (!posthogKey || !posthogHost) {
    if (import.meta.env.DEV) {
      const missingVariable = posthogKey
        ? 'VITE_POSTHOG_HOST'
        : 'VITE_POSTHOG_KEY';
      console.error(
        new Error(
          `${missingVariable} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once ${missingVariable} is configured`,
        ),
      );
    }
    return;
  }

  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-05-30',
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  });
  posthogEnabled = true;
}

export default posthog;
